// extracted by mini-css-extract-plugin
module.exports = {"flexAbout":"About_flexAbout__1iDPS","aboutText1":"About_aboutText1__2Jkc2","aboutText2":"About_aboutText2__2RMox","footer":"About_footer__1Qr6o"};